<ng-container *transloco="let t">
  <div class="flex flex-col gap-4">
    <app-traffic-stats-filter
      class="w-full"
      [initSegment]="initSegment()!"
      (filterChange)="updateTrafficStatsFilter($event)"
    >
      <app-export-button (export)="exportGridCsv()" tooltipValue="{{ t('common.export_as_csv') }}"></app-export-button>
      @if (!chartDisplayed) {
        <button iButton variant="secondary" [iTooltip]="t('common.show_charts')" (click)="toggleChartDisplay(true)">
          <IIcon name="chartLine" />
        </button>
      }
    </app-traffic-stats-filter>

    <app-metric-selector
      [data]="aggregatedData()!"
      [previousPeriodData]="previousAggregatedData()"
      (selectedMetricsChange)="selectMetric($event)"
      [availableMetrics]="ChartMetrics"
      [localStorageKey]="localStorageKey"
      [singleMetricMode]="true"
    />

    @if (chartDisplayed) {
      <app-chart-layout (closeClicked)="toggleChartDisplay(false)" closable>
        <div class="top-cards">
          <div class="mt-4 mr-2 mb-4 w-1/2 px-2 py-2">
            <h3 class="text-center">{{ mainMetric() | metricTitle }}</h3>
            <h3 class="text-center">{{ t("traffic-stats.top_kw_searched_term") }}</h3>
            <app-top-queries-list
              [loadingStatus]="(loader$ | async) || topKwLoadingStatus()"
              [data]="topKeywords()"
              [metric]="mainMetric()"
              [locale]="locale()"
              [currency]="currency()"
              [marketplace]="accountMarketplace()?.marketplace"
            ></app-top-queries-list>
          </div>
          <div class="mt-4 mr-2 mb-4 w-1/2 px-2 py-2">
            <div class="flex">
              <h3 class="flex-auto text-center">{{ mainMetric() | metricTitle }}</h3>
            </div>
            <h3 class="text-center">{{ t("traffic-stats.top_targeted_product") }}</h3>
            <app-top-queries-list
              [loadingStatus]="(loader$ | async) || topProductLoadingStatus()"
              [data]="topProducts()"
              [metric]="mainMetric()"
              [locale]="locale()"
              [currency]="currency()"
              [marketplace]="accountMarketplace()?.marketplace"
            ></app-top-queries-list>
          </div>
        </div>
        <div class="mt-4 mr-2 mb-4 w-1/2 px-2 py-2">
          <div class="flex">
            <h3 class="flex-auto text-center">
              {{ t("traffic-stats.metric_share", [mainMetric() | metricTitle]) }}
            </h3>
          </div>
          <h3>&nbsp;</h3>
          @if (queryStats(); as stats) {
            <app-traffic-stats-chart
              [loader]="(loader$ | async) ?? false"
              [data]="stats.allData"
              [metric]="mainMetric()"
              [locale]="locale()"
              [currency]="currency()"
            ></app-traffic-stats-chart>
          }
        </div>
      </app-chart-layout>
    }

    <app-grid-layout>
      <ag-grid-angular
        #grid
        class="h-[45rem] w-full"
        [rowData]="gridData()"
        [statusBar]="STATUS_BAR"
        [gridOptions]="gridOptions"
        [getGroupRowAgg]="getGroupRowAgg"
      />
    </app-grid-layout>
  </div>
</ng-container>
